import { AppComponent } from '@/app';
import { appConfig } from '@/app.config';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { config } from 'devextreme/common';
import { licenseKey } from './environments/devextreme';
import { environment } from './environments/environment';

import '@/core/utils/string.utils';

if (environment.production) {
  enableProdMode();
}

config({ licenseKey });

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
